import React, { useEffect, useImperativeHandle } from 'react'

import { IActionComponentAPI, IActionComponentProps, IActionSubmitResponse } from '../types'

import useSession from '../../session/useSession'
import RedirectView from './View'

import style from './style.module.scss'

const RedirectAction = React.memo(
  React.forwardRef<IActionComponentAPI, IActionComponentProps>(({ action }, ref) => {
    const session = useSession()
    const url = !session.style?.flutter
      ? action.origin_url
      : action.origin_url.replace(
          action.origin_url.slice(action.origin_url.indexOf('origin=') + 7, action.origin_url.indexOf('%2Fsurvey%2F')),
          'paidviewpoint%3A%2F%2Fapp.paidviewpoint.com'
        )
    // console.log(url)
    // console.log(session.style)
    if (!action.preview && url) window.location.href = url
    useEffect(() => {
      // else {
      session.setWidgetWidth(null)
      session.enableNavigation(action.preview != null)
      session.currentTarget = null
      session.enableNext(action.preview != null)
      // }
    }, [url, action.preview, session])

    useImperativeHandle<IActionComponentAPI, IActionComponentAPI>(
      ref,
      () => {
        return {
          tryNext() {
            return false
          },
          tryPrev() {
            return false
          },
          showValidation() {
            //
          },
          get submitResponse() {
            const submitResponse: IActionSubmitResponse[] = []
            return submitResponse
          },
          get currentQuestionModel(): null {
            return null
          }
        }
      },
      []
    )

    return (
      <div className={style.action}>
        <RedirectView url={url} preview={action.preview != null} />
      </div>
    )
  }),
  (prevProps, nextProps) => prevProps.action === nextProps.action
)

RedirectAction.displayName = 'RedirectAction'

export default RedirectAction
